// extracted by mini-css-extract-plugin
module.exports = {"Row":"EventHeader_Row__3L9aj","Title":"EventHeader_Title__26jta"};